interface MultiplayerProps {
  onNavigate: (to: string) => void;
}

interface ModeEntry {
  slug: string;
  name: string;
  blurb: string;
  to: string;
  available: "everywhere" | "mobile-only";
}

const MODES: readonly ModeEntry[] = [
  {
    slug: "hangman-multi",
    name: "Hangman — 1:1 over Bluetooth",
    blurb:
      "Pair two phones over BLE, take it in turns to send a Morse-style word and guess the other player's. The Hangman classic, drilled with Morse.",
    to: "/play/morse/hangman-multi",
    available: "mobile-only",
  },
  {
    slug: "soundings-multi",
    name: "Soundings — 1:1 over Bluetooth",
    blurb:
      "Two phones, two charts. Each player auto-places a fleet on a 10×10 grid with rocks and cardinal marks. Take turns firing — sink their fleet first, but ground three times on their rocks and you lose.",
    to: "/play/soundings/multi",
    available: "mobile-only",
  },
  {
    slug: "listen",
    name: "Listen to a broadcast",
    blurb:
      "Join an instructor's broadcast and follow their typed message live across Morse, Semaphore, and Flag modules. Up to dozens of listeners on one host within ~10 m.",
    to: "/play/listen",
    available: "mobile-only",
  },
];

/// Two multiplayer surfaces live in different parts of the app —
/// Morse Hangman Multi is a self-contained 1:1 game; Broadcast Listen
/// is a generic listener that joins whichever instructor broadcast is
/// running. This hub pulls them into one place so a student doesn't
/// have to remember where to find each one.
export function Multiplayer({ onNavigate }: MultiplayerProps) {
  return (
    <>
      <h2 style={{ marginTop: 0 }}>Multi-player</h2>
      <p className="muted">
        Two ways to play with other people over Bluetooth — both work
        within ~10 m and require no internet connection. Mobile-only
        for now: the web build doesn't have BLE access.
      </p>

      {MODES.map((m) => (
        <div key={m.slug} className="card">
          <h3 style={{ marginBottom: 4 }}>{m.name}</h3>
          <p className="small muted" style={{ marginBottom: 12 }}>
            {m.blurb}
          </p>
          <p className="small muted" style={{ marginTop: 0, marginBottom: 12 }}>
            <span className="pill">📱 Mobile-only</span>
          </p>
          <button
            onClick={() => onNavigate(m.to)}
            className="secondary"
          >
            Open
          </button>
        </div>
      ))}

      <div className="card">
        <h3 style={{ marginTop: 0 }}>Hosting a broadcast</h3>
        <p className="small muted" style={{ marginBottom: 8 }}>
          To <strong>host</strong> a broadcast (teacher mode), open
          the Translate page for the module you want to teach —{" "}
          <a
            href="/play/morse/translate"
            onClick={(e) => {
              e.preventDefault();
              onNavigate("/play/morse/translate");
            }}
          >
            Morse
          </a>
          {", "}
          <a
            href="/play/semaphore/translate"
            onClick={(e) => {
              e.preventDefault();
              onNavigate("/play/semaphore/translate");
            }}
          >
            Semaphore
          </a>
          , or{" "}
          <a
            href="/play/flags/translate"
            onClick={(e) => {
              e.preventDefault();
              onNavigate("/play/flags/translate");
            }}
          >
            Flags
          </a>{" "}
          — and toggle "Broadcast on" at the top. Whatever you type
          appears live on every student's phone in range.
        </p>
      </div>
    </>
  );
}
